import Comp from "../../assets/HomePagePics/CompanyOverview.png";
import Comp22 from "../../assets/HomePagePics/laptop.png";
import Consumercard from "../../assets/consumercard.jpg";
import Energycard from "../../assets/energycard.jpg";
import Techcard from "../../assets/techcard.jpg";
import Industrycard from "../../assets/industrycard.jpg";

export const ourServiceData = [
  {
    title: "LAND FREIGHT",
    desc: "To best support your ever changing logistics needs, we are continuously evolving our transportation services",
    href: "/landfreight",
  },
  {
    title: "SEA FREIGHT",
    desc: "Sea-Air cargo is the last to be loaded and the first to be unloaded, reducing transshipment times and risk.",
    href: "/oceanfreight",
  },
  {
    title: "AIR FREIGHT",
    desc: "Our AIRFAST services have been designed for customers who need their goods delievered urgently.",
    href: "/airfreight",
  },
  {
    title: "WAREHOUSING",
    desc: "Optimize storage with our advanced warehousing solutions. From short-term to long-term, we streamline your supply chain seamlessly.",
    href: "/warehousing-and-distribution",
  },
];

export const Home4thEssentialData = {
  FirstHeading: "CAREER",
  MainHeading: "DISCOVER OUR CAREER OPPORTUNITIES",
  Description:
    "There will undoubtedly be a job offer that fulfills your requirements. Explore our global opportunities and become a member of the Macworld Technology family.",
  BtnLabelText: "DISCOVER OUR CAREERS SECTION",
};

export const AboutSectionData = {
  title: "STRONGER THAN EVER",
  img: Comp,
  Content1: `As of July 25, 2022, Mac World Logistic has successfully acquired GEFCO, a global leader in automotive logistics and a world authority in supply chain solutions. Together, with our business, we are currently the biggest logistics firm in France and the top worldwide supplier of automotive logistics. We are in the best position we have ever been in and we are moving in the right direction to rank among the top five global logistics companies.`,
  Content2: `With more than 110,000 employees spread across 1,300 locations and more than 170 countries, we are able to provide our clients with rapid logistical solutions.`,
};
export const EcommerceSectionData = {
  individalTitle: "An Individual",
  companyTitle: "A Company",
  img: Comp22,

  Content1: `Mac World does not currently handle the shipping of personal belongings for individuals.`,
  Content2: `Obtain freight prices or inquire about additional services.`,
};

export const OurKeySectors = [
  {
    title: "Health Care",
    img: Consumercard,
  },
  {
    title: "Technology",
    img: Energycard,
  },
  {
    title: "Real-estate",
    img: Techcard,
  },
  {
    title: "E-Commerce",
    img: Industrycard,
  },
];
